@if (dunningTypeTriggerData) {
    <mvs-widget [widgetData]="dunningTypeTriggerData"></mvs-widget>
}
